function o(e) {
  if (!e)
    throw new Error("`contentType` is required");
  var r = e.toLowerCase().replace(/.*\//, "");
  if (!r)
    throw new Error("Unsupported `contentType`: " + e);
  return r;
}
export {
  o as default
};
//# sourceMappingURL=index.es241.js.map
